import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2AdminOrgsByOrganizationIdBillingEntities: build.query<
      GetV2AdminOrgsByOrganizationIdBillingEntitiesApiResponse,
      GetV2AdminOrgsByOrganizationIdBillingEntitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities`,
      }),
    }),
    postV2AdminOrgsByOrganizationIdBillingEntities: build.mutation<
      PostV2AdminOrgsByOrganizationIdBillingEntitiesApiResponse,
      PostV2AdminOrgsByOrganizationIdBillingEntitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities`,
        method: "POST",
        body: queryArg.createBillingEntityRequest,
      }),
    }),
    deleteV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityId:
      build.mutation<
        DeleteV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse,
        DeleteV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}`,
          method: "DELETE",
        }),
      }),
    getV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityId:
      build.query<
        GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse,
        GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}`,
        }),
      }),
    putV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityId:
      build.mutation<
        PutV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse,
        PutV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}`,
          method: "PUT",
          body: queryArg.updateBillingEntityRequest,
        }),
      }),
    postV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSetDefault:
      build.mutation<
        PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSetDefaultApiResponse,
        PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSetDefaultApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}/set-default`,
          method: "POST",
        }),
      }),
    postV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSyncToStedi:
      build.mutation<
        PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSyncToStediApiResponse,
        PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSyncToStediApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}/sync-to-stedi`,
          method: "POST",
        }),
      }),
    getV2ProviderBillingEntities: build.query<
      GetV2ProviderBillingEntitiesApiResponse,
      GetV2ProviderBillingEntitiesApiArg
    >({
      query: () => ({ url: `/v2/provider/billing-entities` }),
    }),
    postV2ProviderBillingEntities: build.mutation<
      PostV2ProviderBillingEntitiesApiResponse,
      PostV2ProviderBillingEntitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-entities`,
        method: "POST",
        body: queryArg.createBillingEntityRequest,
        params: {
          source: queryArg.source,
        },
      }),
    }),
    deleteV2ProviderBillingEntitiesByBillingEntityId: build.mutation<
      DeleteV2ProviderBillingEntitiesByBillingEntityIdApiResponse,
      DeleteV2ProviderBillingEntitiesByBillingEntityIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-entities/${queryArg.billingEntityId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderBillingEntitiesByBillingEntityId: build.query<
      GetV2ProviderBillingEntitiesByBillingEntityIdApiResponse,
      GetV2ProviderBillingEntitiesByBillingEntityIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-entities/${queryArg.billingEntityId}`,
      }),
    }),
    putV2ProviderBillingEntitiesByBillingEntityId: build.mutation<
      PutV2ProviderBillingEntitiesByBillingEntityIdApiResponse,
      PutV2ProviderBillingEntitiesByBillingEntityIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-entities/${queryArg.billingEntityId}`,
        method: "PUT",
        body: queryArg.updateBillingEntityRequest,
        params: {
          source: queryArg.source,
        },
      }),
    }),
    postV2ProviderBillingEntitiesByBillingEntityIdSetDefault: build.mutation<
      PostV2ProviderBillingEntitiesByBillingEntityIdSetDefaultApiResponse,
      PostV2ProviderBillingEntitiesByBillingEntityIdSetDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-entities/${queryArg.billingEntityId}/set-default`,
        method: "POST",
      }),
    }),
    postV2ProviderBillingEntitiesByBillingEntityIdSyncToStedi: build.mutation<
      PostV2ProviderBillingEntitiesByBillingEntityIdSyncToStediApiResponse,
      PostV2ProviderBillingEntitiesByBillingEntityIdSyncToStediApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-entities/${queryArg.billingEntityId}/sync-to-stedi`,
        method: "POST",
        params: {
          source: queryArg.source,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesApiResponse =
  /** status 200 OK */ BillingEntityListResponse;
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesApiArg = {
  organizationId: string;
};
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesApiArg = {
  organizationId: string;
  createBillingEntityRequest: CreateBillingEntityRequest;
};
export type DeleteV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityDeleteResponse;
export type DeleteV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg =
  {
    organizationId: string;
    billingEntityId: string;
  };
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg =
  {
    organizationId: string;
    billingEntityId: string;
  };
export type PutV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PutV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg =
  {
    organizationId: string;
    billingEntityId: string;
    updateBillingEntityRequest: UpdateBillingEntityRequest;
  };
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSetDefaultApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSetDefaultApiArg =
  {
    organizationId: string;
    billingEntityId: string;
  };
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSyncToStediApiResponse =
  /** status 200 OK */ SyncToStediResponse;
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSyncToStediApiArg =
  {
    organizationId: string;
    billingEntityId: string;
  };
export type GetV2ProviderBillingEntitiesApiResponse =
  /** status 200 OK */ BillingEntityListResponse;
export type GetV2ProviderBillingEntitiesApiArg = void;
export type PostV2ProviderBillingEntitiesApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PostV2ProviderBillingEntitiesApiArg = {
  /** Set to intake_billing_stage when the request comes from the intake billing stage, so the server records the stage's measurement events. Omit from Billing Settings. */
  source?: "intake_billing_stage" | null;
  createBillingEntityRequest: CreateBillingEntityRequest;
};
export type DeleteV2ProviderBillingEntitiesByBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityDeleteResponse;
export type DeleteV2ProviderBillingEntitiesByBillingEntityIdApiArg = {
  billingEntityId: string;
};
export type GetV2ProviderBillingEntitiesByBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type GetV2ProviderBillingEntitiesByBillingEntityIdApiArg = {
  billingEntityId: string;
};
export type PutV2ProviderBillingEntitiesByBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PutV2ProviderBillingEntitiesByBillingEntityIdApiArg = {
  billingEntityId: string;
  /** Set to intake_billing_stage when the request comes from the intake billing stage, so the server records the stage's measurement events. Omit from Billing Settings. */
  source?: "intake_billing_stage" | null;
  updateBillingEntityRequest: UpdateBillingEntityRequest;
};
export type PostV2ProviderBillingEntitiesByBillingEntityIdSetDefaultApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PostV2ProviderBillingEntitiesByBillingEntityIdSetDefaultApiArg = {
  billingEntityId: string;
};
export type PostV2ProviderBillingEntitiesByBillingEntityIdSyncToStediApiResponse =
  /** status 200 OK */ SyncToStediResponse;
export type PostV2ProviderBillingEntitiesByBillingEntityIdSyncToStediApiArg = {
  billingEntityId: string;
  /** Set to intake_billing_stage when the request comes from the intake billing stage, so the server records the stage's measurement events. Omit from Billing Settings. */
  source?: "intake_billing_stage" | null;
};
export type BillingAddressResponse = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type SyncStatus =
  | "NOT_SYNCED"
  | "SYNCED"
  | "SYNC_FAILED"
  | "NEEDS_RESYNC";
export type BillingEntityResponse = {
  billing_address: BillingAddressResponse;
  billing_entity_id: string;
  billing_npi: string;
  contact_email: string | null;
  contact_name: string | null;
  contact_phone: string | null;
  created_at: string;
  doing_business_as: string | null;
  is_default: boolean;
  legal_name: string;
  organization_id: string;
  pay_to_address: BillingAddressResponse | null;
  stedi_provider_id: string | null;
  stedi_synced: boolean;
  stedi_synced_at: string | null;
  sync_status: SyncStatus;
  tax_id_masked: string;
  tax_id_type: string;
  taxonomy_code: string | null;
  updated_at: string;
};
export type BillingEntityListResponse = {
  billing_entities: BillingEntityResponse[];
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type BillingAddressResponse2 = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type SyncStatus2 =
  | "NOT_SYNCED"
  | "SYNCED"
  | "SYNC_FAILED"
  | "NEEDS_RESYNC";
export type BillingEntityResponse2 = {
  billing_address: BillingAddressResponse2;
  billing_entity_id: string;
  billing_npi: string;
  contact_email: string | null;
  contact_name: string | null;
  contact_phone: string | null;
  created_at: string;
  doing_business_as: string | null;
  is_default: boolean;
  legal_name: string;
  organization_id: string;
  pay_to_address: BillingAddressResponse2 | null;
  stedi_provider_id: string | null;
  stedi_synced: boolean;
  stedi_synced_at: string | null;
  sync_status: SyncStatus2;
  tax_id_masked: string;
  tax_id_type: string;
  taxonomy_code: string | null;
  updated_at: string;
};
export type BillingAddressSchema = {
  city: string;
  line1: string;
  line2?: string | null;
  state: string;
  zip: string;
};
export type CreateBillingEntityRequest = {
  billing_address: BillingAddressSchema;
  billing_npi: string;
  contact_email?: string | null;
  contact_name?: string | null;
  contact_phone?: string | null;
  doing_business_as?: string | null;
  is_default?: boolean;
  legal_name: string;
  /** Where payers send checks and mail (837P loop 2010AB), when different from the billing address. A PO Box or mailbox service is allowed here. */
  pay_to_address?: BillingAddressSchema | null;
  tax_id: string;
  tax_id_type: string;
  taxonomy_code?: string | null;
};
export type BillingEntityDeleteResponse = {
  /** Whether deletion was successful */
  deleted: boolean;
};
export type BillingAddressUpdateSchema = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type BillingAddressSchema2 = {
  city: string;
  line1: string;
  line2?: string | null;
  state: string;
  zip: string;
};
export type UpdateBillingEntityRequest = {
  billing_address?: BillingAddressUpdateSchema | null;
  billing_npi?: string | null;
  /** Remove the configured pay-to address. */
  clear_pay_to_address?: boolean;
  contact_email?: string | null;
  contact_name?: string | null;
  contact_phone?: string | null;
  doing_business_as?: string | null;
  is_default?: boolean | null;
  legal_name?: string | null;
  /** Where payers send checks and mail (837P loop 2010AB). Omit to leave unchanged; use clear_pay_to_address to remove. */
  pay_to_address?: BillingAddressSchema2 | null;
  tax_id?: string | null;
  tax_id_type?: ("EIN" | "SSN") | null;
  taxonomy_code?: string | null;
};
export type SyncToStediErrorDetails = {
  /** ID of the Stedi provider that already has this NPI and Tax ID (error_code PROVIDER_EXISTS). */
  existing_provider_id?: string | null;
  /** Billing identity fields Stedi requires that are missing or invalid (error_code VALIDATION_FAILED). */
  missing_fields?: string[] | null;
  /** The billing NPI that failed the NPPES check (error_code NPI_MALFORMED or NPI_NOT_FOUND). */
  npi?: string | null;
};
export type SyncNpiCheck = {
  /** Display-ready summary of the check */
  message: string;
  /** The billing NPI that was checked */
  npi: string;
  /** NPPES check result. unverified means NPPES could not be reached and the NPI was not checked. */
  status: "valid" | "wrong_type" | "not_found" | "malformed" | "unverified";
};
export type SyncToStediResponse = {
  details?: SyncToStediErrorDetails | null;
  error?: string | null;
  error_code?: string | null;
  /** NPPES check on the billing NPI. Status unverified means NPPES could not be reached and the sync went ahead unchecked. */
  npi_check?: SyncNpiCheck | null;
  stedi_provider_id?: string | null;
  success: boolean;
  synced_at?: string | null;
};
